import apiClient from '../core/axios';

export interface ParamHint {
  path: string;
  editor: string;
  pii: 'none' | 'low' | 'high';
  defaultValue?: unknown;
  placeholderI18nKey?: string;
}

export interface CuratedPrompt {
  i18nKey: string;
  fillableSlots?: string[];
}

export interface ConsoleActionView {
  id: string;
  domain: 'profiles' | 'segments' | 'events' | 'labels' | 'lists';
  verb: 'read' | 'create' | 'update' | 'delete' | 'analyze';
  mutating: boolean;
  destructive: boolean;
  i18nKey: string;
  paramsHints: ParamHint[];
  curatedPrompts: CuratedPrompt[];
  pageContextHooks: string[];
}

export const consoleAiActionsService = {
  list: async (pageContext?: string): Promise<ConsoleActionView[]> => {
    const { data } = await apiClient.get('/console-ai/actions', {
      params: pageContext ? { pageContext } : undefined,
    });
    return data?.data ?? data;
  },
};
